import { useParseRouteActions } from "../../../helpers/GlobalHelper";
import LmsTable from "../ui/LmsTable";

const LmsServicingCurrentInspections = ({ params = {}, history }) => {
  const { isActionAllowed } = useParseRouteActions(params);
  if (!isActionAllowed) {
    history.goBack();
  }

  return (
    <LmsTable
      actionButtons={["export"]}
      apiSuffix="inspections/servicing-current-inspections"
      skipClick
      columnLabelsDictionary={{
        loanNumber: "Loan #",
        tcname: "TC Name",
        tcphoneNumber: "TC Phone Number",
      }}
    />
  );
};

export default LmsServicingCurrentInspections;
